import { getDefinition } from "../catalog";
import { getStateOption } from "../simulate/states";
import type { SimulateState } from "../simulate-store-slice";
import type { System } from "../types";
import { canonicalJson } from "./request-hash";

/** Only declared inputs for the current drawing travel with a request. The
 * editor may retain state for deleted/replaced parts until its next reload. */
export function snapshotAssistantSimulation(system: System, state: SimulateState): SimulateState {
  const snapshot: SimulateState = { componentStates: {}, batterySoc: {}, loadStates: {} };
  for (const node of system.nodes) {
    if (node.kind !== "component") continue;
    const def = getDefinition(node.definitionId, node.customDefinition);
    if (!def) continue;
    const selected = state.componentStates[node.id];
    if (selected && getStateOption(def, selected)) snapshot.componentStates[node.id] = selected;
    const soc = state.batterySoc[node.id];
    if (def.category === "battery" && Number.isFinite(soc) && soc >= 0 && soc <= 1) snapshot.batterySoc[node.id] = soc;
    const active = state.loadStates[node.id]?.active;
    if (def.category === "load" && typeof active === "boolean") snapshot.loadStates[node.id] = { active };
  }
  return snapshot;
}

export function sameAssistantSimulation(a: SimulateState | undefined, b: SimulateState): boolean {
  return canonicalJson(a ?? { componentStates: {}, batterySoc: {}, loadStates: {} }) === canonicalJson(b);
}
